module.exports = __webpack_public_path__ + "img/logo@3x.72281f65.png";